<script>
import botService from '@/services/amio/bot.service'
import isEmpty from 'ramda/src/isEmpty'
import { ROUTE_NAMES } from '@/router'
import { ITEM_IDS } from '@/utils/editor.constants'

export default {
  name: 'Redirect',

  async beforeRouteEnter(to, from, next) {
    const bots = await botService.listBots()
    return isEmpty(bots) ?
      next({ name: ROUTE_NAMES.bots, params: { botId: ITEM_IDS.NEW } }) :
      next({ name: ROUTE_NAMES.answers, params: { botId: bots[0].id } })
  }
}
</script>
